import { useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";
import findAccounts from "../store/account/actions/findAccounts";
import findClients from "../store/clients/actions/findClients";
import findNotifications from "../store/notificationsList/actions/findNotifications";
import { findStatus } from "../store/utils/actions/findStatus";
import subscribeNotifications from "../store/userAuthentication/actions/subscribeNotifications";
import { validateSession } from "../store/userAuthentication/actions/validateSession";
import { findCategory } from "../store/utils/actions/findCategory";
import { isFulfilled } from "@reduxjs/toolkit";
import { findSourceOrganization } from "../store/users/actions/findSourceOrganization";

export const FetchInitialData: React.FC = () => {
  console.log("Fetch Data Render");

  const dispatch = useDispatch();
  useEffect( () => {
    isFulfilled(dispatch(validateSession()));
    dispatch(findClients());
    dispatch(findAccounts());
    dispatch(findNotifications());
    dispatch(subscribeNotifications());
    dispatch(findStatus());
    dispatch(findCategory());
    dispatch(findSourceOrganization());
  }, [dispatch]);

  return <></>;
};
